import React, {Fragment} from 'react';
import {Route} from 'react-router-dom';

// Páginas de login e cadastro

import Login from './Login';
import Register from './Register';
import ForgotPassword from './ForgotPassword';
import SelectCustomer from './SelectCustomer';
import Recovery from './Recovery';

const UserPages = ({match}) => (
    <Fragment>
        <div className="app-container">
            <Route path="/auth/login" component={Login}/>
            <Route path="/auth/register" component={Register}/>
            <Route path="/auth/forgot-password" component={ForgotPassword}/>
            <Route path="/auth/select-customer" component={SelectCustomer}/>
            <Route path="/auth/recovery" component={Recovery}/>
        </div>
    </Fragment>
);

export default UserPages;